import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClassService } from '../../serivce/class.service';
import { JobsService } from '../../serivce/jobs.service';
@Component({
  selector: 'app-delete-jobs-dialog',
  templateUrl: './delete-jobs-dialog.component.html',
  styleUrls: ['./delete-jobs-dialog.component.css']
})
export class DeleteJobsDialogComponent implements OnInit {
  datas;
  constructor(private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private service: JobsService,
  ) {
    this.datas = data;
  }
  ngOnInit() {
  }
  delJobs() {
    debugger
    var model = { Id: this.datas.model.Id }
    this.spinner.show();
    this.service.delJobs(model).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error(res.content, "Thất bại");
      }
    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
